import React from 'react';
import { View } from 'react-native';

import { Text, TextInput } from '../../components';
import { useThemedStyles } from '../../hooks/useThemedStyles';

const FIELDS = [
	{ field: 'name', label: 'Name', inputProps: { autoCapitalize: 'words', autoComplete: 'name', textContentType: 'name' } },
	{ field: 'role', label: 'Role', inputProps: { autoCapitalize: 'sentences' } },
	{ field: 'phoneNumber', label: 'Phone', inputProps: { keyboardType: 'phone-pad', autoComplete: 'tel', textContentType: 'telephoneNumber' } },
	{ field: 'email', label: 'Email', inputProps: { keyboardType: 'email-address', autoCapitalize: 'none', autoComplete: 'email', textContentType: 'emailAddress' } },
];

export const EMPTY_LEAD_CONTACT = {
	name: '',
	role: '',
	phoneNumber: '',
	email: '',
};

// Turns contact form values into the lead's inline contact fields, e.g. personName or secondaryPersonEmail.
export const getLeadContactInput = (values, prefix = 'person') => ({
	[`${prefix}Name`]: values.name.trim(),
	[`${prefix}Role`]: values.role.trim(),
	[`${prefix}PhoneNumber`]: values.phoneNumber.trim(),
	[`${prefix}Email`]: values.email.trim(),
});

export const hasLeadContactValues = values => Object.values(values).some(value => value.trim());

const LeadContactFields = ({ values, onChange, disabled = false }) => {
	const styles = useThemedStyles(createStyles);

	return FIELDS.map(({ field, label, inputProps }) => (
		<View key={field} style={styles.field}>
			<Text style={styles.label}>{label}</Text>
			<TextInput
				{...inputProps}
				value={values[field]}
				onChange={value => onChange(field, value)}
				disabled={disabled}
			/>
		</View>
	));
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	field: {
		marginBottom: space.md,
		gap: 6,
	},
	label: {
		...type.secondarySemibold,
		color: colors.text,
	},
});

export default LeadContactFields;
